export const hr = {
  // Header
  header: {
    home: "Početna",
    products: "Proizvodi",
    about: "O Nama",
    ourWorks: "Prodhim",
    contact: "Kontakt",
    calculator: "Kalkulator",
    catalog: "Katalog",
  },
  // Banner
  banner: {
    title: "Izvrsnost u proizvodnji premium čelika",
    description:
      "Transformirajte svoje projekte s našim visokokvalitetnim čeličnim proizvodima. Od prilagođene proizvodnje do standardnih profila, nudimo precizno inženjerstvo i izvanrednu uslugu za svaku industrijsku potrebu",
    contactUs: "Kontaktirajte Nas",
    learnMore: "Saznajte Više",
  },
  // WhoWeAre
  whoWeAre: {
    aboutUs: "O nama",
    title: "Tko smo mi",
    description:
      "MTA je vodeća tvrtka za proizvodnju čelika posvećena isporuci proizvoda vrhunske kvalitete i izvanredne usluge. S desetljećima stručnosti u proizvodnji i obradi čelika, kombiniramo tradicionalnu izradu s modernom tehnologijom kako bismo zadovoljili različite potrebe industrija diljem Kosova i šire.",
    learnMore: "Saznajte Više",
    yearsOfExperience: "Godina iskustva",
    projectsPerYear: "Projekata godišnje",
    clientSatisfaction: "Zadovoljstvo klijenata",
    tradesPerYear: "Trgovina godišnje",
  },
  // QuickAbout
  quickAbout: {
    profileMetalike: "Metalni profili",
    profileMetalikeDesc:
      "Nudimo metalne profile različitih dimenzija: 15x15 - 140x140; fi 20 do fi150, debljina 0.9-5mm.",
    slitingLine: "Linija za rezanje",
    slitingLineDesc:
      "Režemo lim u trake debljine 0.5mm do 10mm sa širinom do 1500mm",
    cutToLength: "Rezanje na duljinu",
    cutToLengthDesc:
      "Režemo lim (ploče), debljine od 0.5-12mm, različitih širina i duljina",
    pvc: "PVC",
    pvcDesc: "Proizvodimo sve vrste *metalnih profila* za PVC vrata i prozore",
  },
  // Stats
  stats: {
    companyFounded: "Tvrtka osnovana",
    companyFoundedDesc:
      "MTA je osnovana s vizijom pružanja visokokvalitetnih čeličnih proizvoda na tržište Kosova, počevši s malim objektom i predanim timom.",
    majorExpansion: "Veliko proširenje",
    majorExpansionDesc:
      "Proširili smo naš proizvodni kapacitet najsuvremenijom opremom i udvostručili naš proizvodni objekt kako bismo zadovoljili rastuće tržišne potrebe.",
    industryLeadership: "Vodeća pozicija u industriji",
    industryLeadershipDesc:
      "Postali smo jedan od vodećih proizvođača čelika na Kosovu, služeći različitim industrijama s širokim rasponom proizvoda i neusporedivim standardima kvalitete.",
  },
  // Catalogue
  catalogue: {
    aboutUs: "O nama",
    productCatalogue: "Katalog proizvoda",
    rectangular: "Pravokutni",
    rectangularDesc: "Izdržljiv oblik idealan za okvirne strukture",
    circular: "Kružni",
    circularDesc: "Gladak i jak za zakrivljene primjene",
    square: "Kvadratni",
    squareDesc: "Svestran dizajn za opću gradnju",
    profileU: "Profil u",
    profileUDesc: "Stabilna potpora za univerzalne primjene",
    profileH: "Profil h",
    profileHDesc: "Teški profil dizajniran za maksimalni kapacitet nosivosti",
    elipse: "Elipsa",
    elipseDesc: "Elegantan oblik za moderne strukturne potrebe",
    profileP: "Profil p",
    profilePDesc: "Kompaktan profil za precizno izgrađene sustave",
    profileI: "Profil i",
    profileIDesc: "Lagani profil koji nudi maksimalnu krutost",
    roundBars: "Okrugle šipke",
    roundBarsDesc:
      "Čvrste čelične šipke koje nude snagu i preciznost za industrijsku upotrebu",
    profileL: "Profil l",
    profileLDesc:
      "Dizajniran za snažnu potporu i pouzdane strukturne performanse",
    flets: "Flats",
    fletsDesc:
      "Čvrste, glatke čelične ploče za svestranu upotrebu u proizvodnji",
    learnMore: "Saznajte Više",
  },
  // TradingProducts
  tradingProducts: {
    title: "Otkrijte naše trgovačke proizvode",
    description: "Kao tvrtka, trgujemo ovim proizvodima u velikim količinama",
  },
  // Factory
  factory: {
    ourFactory: "Naša tvornica",
    title: "Kako izgleda naša tvornica?",
    slide1:
      "Naša glavna proizvodna hala sadrži najsuvremenije strojeve za rezanje, oblikovanje i završnu obradu čeličnih proizvoda s preciznošću i učinkovitošću",
    slide2:
      "Napredni sustavi kontrole kvalitete osiguravaju da svaki proizvod ispuni međunarodne standarde prije nego što napusti naš objekt.",
    slide3:
      "Naš predani tim stručnih profesionalaca upravlja modernom opremom kako bi pružio konzistentne, visokokvalitetne rezultate.",
    slide4:
      "Prostrani skladišni objekti omogućuju nam održavanje opsežnog inventara i osiguravaju brzu isporuku našim klijentima.",
    slide5:
      "Naš odjel za proizvodnju rješava prilagođene projekte s preciznim zavarivanjem i montažnim mogućnostima za složene čelične strukture.",
  },
  // ContactForm
  contactForm: {
    title: "Stupimo u Kontakt",
    titleHighlight: "Stupimo",
    distributorDesc:
      "Ako ste distributer koji želi surađivati s nama. Ispunite svoje podatke u nastavku, a naš tim će se javiti kako bismo razgovarali o mogućnostima suradnje i isporuke u velikim količinama",
    customerDesc:
      "Bilo da trebate informacije o proizvodu, podršku ili samo želite kontaktirati, tu smo da pomognemo. Ispunite svoje podatke, a naš tim će odgovoriti što je prije moguće.",
    distributor: "Distributer",
    customer: "Kupac",
    name: "Ime",
    surname: "Prezime",
    email: "Email",
    phoneNumber: "Broj Telefona",
    message: "Poruka",
    uploadFile: "Prenesi datoteku",
    noFileChosen: "Nije odabrana datoteka",
    submitForm: "Pošaljite obrazac",
  },
  // Footer
  footer: {
    trustedBy:
      "Povjerenje stotina klijenata diljem regije za našu predanost kvaliteti, inovacijama i pouzdanoj isporuci.",
    contactUs: "Kontaktirajte Nas",
    products: "Proizvodi",
    circular: "Kružni",
    square: "Kvadratni",
    rectangular: "Pravokutni",
    elipse: "Elipsa",
    profileU: "Profil u",
    profileZ: "Profil Z",
    profileP: "Profil p",
    socialMedia:
      "Također nas možete posjetiti na našim društvenim mrežama kako biste saznali više o nama",
    ourSocialMedia: "Naše društvene mreže",
    allRightsReserved: "Sva prava zadržana",
  },
  // Pages
  pages: {
    about: {
      title: "Naša priča, izrada kvalitete u svakoj leguri",
      description:
        "Otkrijte naš put od male čelične radionice do jedne od vodećih proizvodnih tvrtki na Kosovu. Saznajte o našoj predanosti kvaliteti, inovacijama i zadovoljstvu klijenata",
    },
    products: {
      title: "Premium čelični profili za svaku primjenu",
      description:
        "Otkrijte naš put od male čelične radionice do jedne od vodećih proizvodnih tvrtki na Kosovu. Saznajte o našoj predanosti kvaliteti, inovacijama i zadovoljstvu klijenata",
    },
    work: {
      title: "Naša baština snage i preciznosti",
      description:
        "Istražite našu tvornicu za izradu čeličnih konstrukcija koja opslužuje Kosovo i regiju. Opremljena modernom opremom i stručno osposobljenim kadrom, MTA Steel isporučuje precizna, izdržljiva i visokokvalitetna rješenja od čelika.",
    },
  },
  // Story
  story: {
    year1999:
      "Osnovana MTA s vizijom pružanja visokokvalitetnih čeličnih proizvoda na lokalno tržište, počevši s osnovnim profilima i uslugama prilagođene proizvodnje",
    year2003:
      "Proširili smo našu liniju proizvoda kako bismo uključili specijalizirane profile h počeli služiti većim industrijskim klijentima diljem Kosova",
    year2007:
      "Uložili smo u modernu opremu za rezanje i oblikovanje, značajno povećavajući proizvodni kapacitet i standarde kvalitete proizvoda",
    year2010:
      "Udvostručili smo veličinu našeg objekta i uveli napredne sustave kontrole kvalitete kako bismo ispunili međunarodne standarde proizvodnje",
    year2014:
      "Postigli ISO certifikaciju i počeli izvoziti proizvode u susjedne zemlje, uspostavljajući MTA kao regionalnog igrača",
    year2018:
      "Implementirali automatizirane proizvodne linije i digitalno upravljanje zalihama, poboljšavajući učinkovitost i uslugu klijentima",
    year2021:
      "Proširili smo naš tim na preko 50 stručnih profesionalaca i uveli ekološki prihvatljive proizvodne prakse",
    year2023:
      "Pokrenuli naš sveobuhvatni online katalog i portal za klijente, olakšavajući klijentima pristup našim proizvodima",
    year2025:
      "Slaveći više od 25 godina izvrsnosti, služeći stotinama klijenata s opsežnim rasponom premium čeličnih proizvoda",
  },
  // Values
  values: {
    ourValues: "Naše vrijednosti",
    title: "Za što zauzimamo stajalište",
    quality: "Kvaliteta",
    qualityDesc:
      "Nikada ne kompromitiramo kvalitetu. Svaki proizvod prolazi rigorozno testiranje i inspekciju kako bismo osigurali da ispunjava najviše industrijske standarde i premašuje očekivanja klijenata",
    innovation: "Inovacija",
    innovationDesc:
      "Prihvaćamo napredne tehnologije i moderne procese kako bismo kontinuirano poboljšali učinkovitost, preciznost i performanse u svakom proizvodu koji isporučujemo",
    integrity: "Integritet",
    integrityDesc:
      "Vodimo svaki aspekt našeg poslovanja s poštenjem, transparentnošću i odgovornošću. Od nabave materijala do isporuke konačnih proizvoda, poštujemo svoje obveze, gradimo povjerenje s našim partnerima i održavamo etičke standarde u svemu što radimo",
    excellence: "Izvrsnost",
    excellenceDesc:
      "Vodimo svaki aspekt našeg poslovanja s poštenjem, transparentnošću i odgovornošću. Od nabave materijala do isporuke konačnih proizvoda, poštujemo svoje obveze, gradimo povjerenje s našim partnerima i održavamo etičke standarde u svemu što radimo",
  },
  // MainStats
  mainStats: {
    ourExpertise: "Naša stručnost",
    title: "Certificirani smo i vrlo napredni u onome što radimo",
    description:
      "Naša predanost izvrsnosti potvrđena je međunarodnim certifikatima i priznanjem industrije. Održavamo najviše standarde u upravljanju kvalitetom, sigurnosnim protokolima i ekološkoj odgovornosti u svim operacijama",
    iso9001: "Iso 9001",
    iso9001Desc:
      "Certifikacija sustava upravljanja kvalitetom koja osigurava konzistentnu kvalitetu u našim proizvodnim procesima",
    oshaSafety: "Osha sigurnost",
    oshaSafetyDesc:
      "Certifikacija uprave za sigurnost i zdravlje na radu za standarde sigurnosti na radnom mjestu",
    iso14001: "Iso 14001",
    iso14001Desc:
      "Certifikacija sustava upravljanja okolišem za održive proizvodne prakse",
  },
  // QuickOverview
  quickOverview: {
    description:
      "MTA radi s 8 proizvodnih linija, od kojih su 4 linije za proizvodnju metalnih profila, 2 linije za rezanje (linija za rezanje), i 1 rezanje na duljinu (rezanje u liniji) različitih limenih ploča, proizvodnja metalnih profila za PVC vrata i prozore",
  },
  // NewBorn
  newBorn: {
    description:
      "Ikonični spomenik NEWBORN je s ponosom povjeren našoj tvrtki za njegovu proizvodnju i izvedbu, označavajući projekt i tehničke složenosti i simboličke vrijednosti. Kroz preciznu proizvodnju čelika, strukturnu stručnost i detaljnu završnu obradu, isporučili smo izdržljiv spomenik koji odražava kreativnost, snagu i moderan dizajn",
  },
  // Showroom
  showroom: {
    newbornMonument: "Spomenik newborn",
    newbornMonumentDesc:
      "Isporučena precizno izrezana čelična slova za ikonični NEWBORN spomenik Kosova, pokazujući našu sposobnost za složene arhitektonske metalne radove",
  },
  // Newsletter
  newsletter: {
    title: "Sve što vam treba za vaše projekte",
    description:
      "MTA pruža potpuna čelična rješenja s opsežnim zalihama, fleksibilnim opcijama prilagodbe i brzom isporukom. Partnerujte s nama za pouzdanu opskrbu, tehničku stručnost i izvanrednu uslugu tijekom cijelog životnog ciklusa vašeg projekta",
    qualityAssurance: "Jamstvo kvalitete",
    qualityAssuranceDesc:
      "Premium materijali i rigorozno testiranje osiguravaju najviše standarde u svakom proizvodu koji isporučujemo",
    expertCraftsmanship: "Stručna izrada",
    expertCraftsmanshipDesc:
      "Desetljeća iskustva u kombinaciji s modernim tehnikama za pružanje izvanrednih rezultata",
  },
  // SteelSupply
  steelSupply: {
    title: "Nudimo veleprodaju čelika",
    description:
      "Naša tvrtka pruža veleprodajne količine čeličnih proizvoda za distributere, građevinske tvrtke i velike industrijske projekte. Ako trebate velike narudžbe, konzistentnu opskrbu ili posebne cijene za kupnje velikog obujma, naš tim je spreman podržati vas pouzdanom i učinkovitom uslugom",
    contactUs: "Kontaktirajte Nas",
  },
  // Motivational
  motivational: {
    line1: "Ne oblikujemo samo čelik",
    line2: "oblikujemo",
    line3: "SAMU SNAGU",
  },
};
